
const { registerPlugin } = wp.plugins

const render = () => {};

registerPlugin( 'woofood-checkout-blocks', {
	render,
	scope: 'woocommerce-checkout',
} );